import { ReactElement, useEffect } from 'react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import Base from './Base';
import './Base.scss';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 15 * 60 * 1000,
      refetchOnWindowFocus: false,
    },
  },
});

export default function Index(): ReactElement {
  useEffect(() => {
    document.body.classList.add('rp-mf-app');
  }, []);

  return (
    <QueryClientProvider client={queryClient}>
      <Base />
    </QueryClientProvider>
  );
}
